// AboutPage.js
import React from 'react';
import '../index.css';
import '../styles/AboutPage.css';
import '../styles/AccountPage.css'; // Import AccountPage styles
import { useEffect, useState } from "react";
import { useFormSubmit } from '../services/useFormSubmit';
import Jorrit from '../components/team/Jorrit_profile.png';
import George from '../components/team/George_profile.png';
import AnnaMaria from '../components/team/Annamaria_profile.png';
import Priscille from '../components/team/Priscille_profile.png';
import Dennis from '../components/team/Dennis_profile.png';
import Bram from '../components/team/Bram_profile.png';
import Nicolas from '../components/team/Nicolas_profile.png';
import Cas from '../components/team/Cas_profile.jpg';
import Miguel from '../components/team/Miguel_profile.jpg';
import Aicha from '../components/team/Aicha_profile.png';

// Import Swiper components
import 'swiper/css';
import 'swiper/css/autoplay';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';

function AboutPage() {
  const { submitStatus, handleSubmit } = useFormSubmit();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 720);
    };
    window.addEventListener('resize', handleResize);
    handleResize(); // Set initial value
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const teamMembers = [
    { img: George, name: 'George', title: 'Co-Founder' },
    { img: AnnaMaria, name: 'Anna Maria', title: 'Software Engineer' },
    { img: Dennis, name: 'Dennis', title: 'AI Developer' },
    { img: Priscille, name: 'Priscille', title: 'Business Developer' },
    { img: Bram, name: 'Bram', title: 'AI Developer' },
    { img: Nicolas, name: 'Nicolas', title: 'AI Developer' },
    { img: Cas, name: 'Cas', title: 'Business Developer' },
    { img: Miguel, name: 'Miguel', title: 'Quality Control' },
    { img: Aicha, name: 'Aicha', title: 'Business Developer' },
    { img: Jorrit, name: 'Jorrit', title: 'Co-Founder' },
  ];

  return (
    <div className="account-page">
      <div className="account-container">
        <h1 className="account-title">About Us</h1>
        <p className="about-subtitle">Transforming market research with AI</p>

        {/* Mission Section */}
        <div className="account-card mission-card" style={{background:'white'}}>
          <h2>Our Mission</h2>
          
          <div style={{margin: '0 3rem'}}>
            <p className="mission-text">
              InstantFlows is an innovative AI startup in beta, developing tools to make market research more accessible and efficient.
            </p>
            
            <p className="mission-text">
              Our platform uses AI to generate synthetic survey responses from virtual personas, helping you quickly test concepts, messages, and ideas without recruiting real participants.
            </p>
            
            <p className="mission-text">
              Validate your ideas with AI in minutes, not weeks - whether you're exploring pricing options, testing brand messaging, or evaluating product concepts before investing in traditional research.
            </p>
          </div>
        </div>

        {/* Team Section */}
        <div className="account-card team-card">
          <h2>Meet Our Team</h2>
          
          {isMobile ? (
            <div className="team-swiper-container">
              <Swiper 
                modules={[Autoplay]}
                spaceBetween={10}
                slidesPerView={1}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false
                }}
                speed={1500}
              >
                {teamMembers.map((member, index) => (
                  <SwiperSlide key={index} className="team-swiper-slide">
                    <div className="team-member-card">
                      <img 
                        src={member.img} 
                        alt={member.name} 
                        className="team-member-image" 
                      />
                      <div className="team-member-info">
                        <h3 className="team-member-name">{member.name}</h3>
                        <p className="team-member-title">{member.title}</p>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          ) : (
            <div className="team-grid">
              {teamMembers.map((member, index) => (
                <div key={index} className="team-member-card">
                  <img 
                    src={member.img} 
                    alt={member.name} 
                    className="team-member-image"
                  />
                  <div className="team-member-info">
                    <h3 className="team-member-name">{member.name}</h3>
                    <p className="team-member-title">{member.title}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
          
          <div className="careers-link">
            <p>Interested in working with us? Check out our <a href="/careers">career opportunities</a>.</p>
          </div>
        </div>

        {/* Social Media Section */}
        <div className="account-card social-card">
          <h2>Connect With Us</h2>
          
          <div className="social-icons-container">
            <a 
              href="https://x.com/Instantflows" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-link"
            >
              <div className="social-icon-wrapper">
                <img 
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/X_icon.svg/768px-X_icon.svg.png" 
                  alt="Twitter/X" 
                  className="social-icon-image"
                />
              </div>
              <span className="social-platform-name">Twitter</span>
            </a>
            
            <a 
              href="https://www.linkedin.com/company/instantflows/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-link"
            >
              <div className="social-icon-wrapper">
                <img 
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/LinkedIn_logo_initials.png/960px-LinkedIn_logo_initials.png" 
                  alt="LinkedIn" 
                  className="social-icon-image" 
                />
              </div>
              <span className="social-platform-name">LinkedIn</span>
            </a>
            
            <a 
              href="https://www.instagram.com/instantflows/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-link"
            >
              <div className="social-icon-wrapper">
                <img 
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/2048px-Instagram_icon.png" 
                  alt="Instagram" 
                  className="social-icon-image" 
                />
              </div>
              <span className="social-platform-name">Instagram</span>
            </a>
          </div>
        </div>

        {/* Contact Form */}
        <div className="account-card contact-card">
          <h2>Contact Us</h2>
          
          <form 
            id="interest-form" 
            action="https://script.google.com/macros/s/AKfycbz3X8mRhapnoT9XdfOdhJjXJhO2Q5X0Sz-0FbLsjCK81WlB0rOHiTP1ib3I6acjfC5dmg/exec" 
            method="POST" 
            className="contact-form"
            onSubmit={(e) => handleSubmit(e, 'interest-form')}
          >
            <input 
              type="text" 
              name="Name" 
              placeholder="Your Name" 
              required 
              className="contact-input"
            />
            
            <input 
              type="email" 
              name="Email" 
              placeholder="Your Email" 
              required 
              className="contact-input"
            />
            
            <textarea 
              name="question" 
              placeholder="How can we help you today?" 
              required 
              className="contact-textarea"
            ></textarea>
            
            <button type="submit" className="contact-submit-button">
              Send Message
            </button>
            
            {submitStatus.message && (
              <div className={`form-message ${submitStatus.isError ? 'error' : 'success'}`}>
                {submitStatus.message}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;